import { render } from "./page-header.html?vue&type=template&id=c106c64c&scoped=true&ts=true&external"
import script from "./page-header.ts?vue&type=script&lang=ts&external"
export * from "./page-header.ts?vue&type=script&lang=ts&external"

import "./page-header.scss?vue&type=style&index=0&id=c106c64c&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c106c64c"]])

export default __exports__